import {useFormatCurrency} from './useFormatCurrency';

export const useQuantityFormat = () => {
  const formatCurrency = useFormatCurrency();
  return (value: number) =>
    formatCurrency(value * 100, '', {
      withoutCurrencySymbol: true,
      withoutDecimal: true,
    });
};
